export function initNav() {
  const button = document.querySelector<HTMLButtonElement>("#menu-button");
  const nav = document.querySelector<HTMLElement>("#site-nav");
  if (!button || !nav) return;

  const close = () => {
    nav.classList.remove("is-open");
    button.setAttribute("aria-expanded", "false");
    document.body.classList.remove("nav-open");
  };

  button.addEventListener("click", () => {
    const open = nav.classList.toggle("is-open");
    button.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.classList.toggle("nav-open", open);
  });

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", close);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });
}
